import React from 'react';
import PropTypes from 'prop-types';
import ListStyles from './styled';

const List = ({ title = '', items = [] }) => (
  <ListStyles>
    {title && <h2 className='type-h3'>{title}</h2>}
    <ul>
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  </ListStyles>
);

List.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
};

export default List;
